import axios from 'axios';
import { aiAnalysisAPI } from '../../../common/api/aiAnalysis';
import { TOAST_MESSAGE } from '../../../common/components/Toasts/Toast';
import { toastActions } from '../../toast/actions';

export const AI_ANALYSIS_FETCH_REQUEST = 'AI_ANALYSIS_FETCH_REQUEST';
export const AI_ANALYSIS_FETCH_SUCCESS = 'AI_ANALYSIS_FETCH_SUCCESS';
export const AI_ANALYSIS_FETCH_FAILURE = 'AI_ANALYSIS_FETCH_FAILURE';
export const AI_ANALYSIS_FETCH_NOT_FOUND = 'AI_ANALYSIS_FETCH_NOT_FOUND';
export const AI_ANALYSIS_RETRY_REQUEST = 'AI_ANALYSIS_RETRY_REQUEST';
export const AI_ANALYSIS_RETRY_SUCCESS = 'AI_ANALYSIS_RETRY_SUCCESS';
export const AI_ANALYSIS_RETRY_FAILURE = 'AI_ANALYSIS_RETRY_FAILURE';
export const AI_ANALYSIS_REVIEW_REQUEST = 'AI_ANALYSIS_REVIEW_REQUEST';
export const AI_ANALYSIS_REVIEW_SUCCESS = 'AI_ANALYSIS_REVIEW_SUCCESS';
export const AI_ANALYSIS_REVIEW_FAILURE = 'AI_ANALYSIS_REVIEW_FAILURE';
export const AI_ANALYSIS_CONFIRM_REQUEST = 'AI_ANALYSIS_CONFIRM_REQUEST';
export const AI_ANALYSIS_CONFIRM_SUCCESS = 'AI_ANALYSIS_CONFIRM_SUCCESS';
export const AI_ANALYSIS_CONFIRM_FAILURE = 'AI_ANALYSIS_CONFIRM_FAILURE';

function fetchAnalysis(quoteVersionId, config = {}) {
  return dispatch => {
    dispatch({ type: AI_ANALYSIS_FETCH_REQUEST, quoteVersionId });
    return aiAnalysisAPI
      .getAnalysis(quoteVersionId, config)
      .then(data => {
        const analysis = data.quoteAiAnalysis;
        if (!analysis) {
          dispatch({
            type: AI_ANALYSIS_FETCH_NOT_FOUND,
            quoteVersionId,
            automaticAnalysis: data.automaticAnalysis,
          });
          return data;
        }

        dispatch({
          type: AI_ANALYSIS_FETCH_SUCCESS,
          quoteVersionId,
          analysis,
        });
        return data;
      })
      .catch(error => {
        if (axios.isCancel && axios.isCancel(error)) return null;
        if (error.response && error.response.status === 404) {
          return dispatch({ type: AI_ANALYSIS_FETCH_NOT_FOUND, quoteVersionId });
        }
        return dispatch({ type: AI_ANALYSIS_FETCH_FAILURE, quoteVersionId });
      });
  };
}

function retryAnalysis(quoteVersionId) {
  return dispatch => {
    dispatch({ type: AI_ANALYSIS_RETRY_REQUEST, quoteVersionId });
    return aiAnalysisAPI
      .retryAnalysis(quoteVersionId)
      .then(data => {
        dispatch({
          type: AI_ANALYSIS_RETRY_SUCCESS,
          quoteVersionId,
          analysis: data.quoteAiAnalysis,
        });
        return data;
      })
      .catch(error => {
        dispatch({ type: AI_ANALYSIS_RETRY_FAILURE, quoteVersionId, error });
        dispatch(toastActions.error(TOAST_MESSAGE.error.update));
        throw error;
      });
  };
}

function confirmAnalysis(quoteVersionId) {
  return dispatch => {
    dispatch({ type: AI_ANALYSIS_CONFIRM_REQUEST, quoteVersionId });
    return aiAnalysisAPI
      .confirmAnalysis(quoteVersionId)
      .then(data => {
        dispatch({
          type: AI_ANALYSIS_CONFIRM_SUCCESS,
          quoteVersionId,
          analysis: data.quoteAiAnalysis,
        });
        dispatch(toastActions.success(TOAST_MESSAGE.success.update));
        return data;
      })
      .catch(error => {
        dispatch({ type: AI_ANALYSIS_CONFIRM_FAILURE, quoteVersionId, error });
        dispatch(toastActions.error(TOAST_MESSAGE.error.update));
        throw error;
      });
  };
}

function saveReview(quoteVersionId, review) {
  return dispatch => {
    dispatch({ type: AI_ANALYSIS_REVIEW_REQUEST, quoteVersionId });
    return aiAnalysisAPI
      .updateAnalysis(quoteVersionId, review)
      .then(data => {
        dispatch({
          type: AI_ANALYSIS_REVIEW_SUCCESS,
          quoteVersionId,
          analysis: data.quoteAiAnalysis,
        });
        dispatch(toastActions.success(TOAST_MESSAGE.success.update));
        return data;
      })
      .catch(error => {
        dispatch({ type: AI_ANALYSIS_REVIEW_FAILURE, quoteVersionId, error });
        dispatch(toastActions.error(TOAST_MESSAGE.error.update));
        throw error;
      });
  };
}

export const aiAnalysisActions = { fetchAnalysis, retryAnalysis, saveReview, confirmAnalysis };
